export default __webpack_public_path__ + "static/MWP-PATRONAT-Mieczysław-Struk-poziom-kolor-2021-c6e631cf82f748f789f017f99dd289f1.png";